export default __webpack_public_path__ + "static/media/external-block-diagram.41023f92.png";